import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {onMounted, ref} from "vue";
import {useStore} from "./store";
import DetailsScreen from "./components/DetailsScreen.vue";
import PlayerComponent from "./components/PlayerComponent.vue";
import PreviewScreen from "./components/PreviewScreen.vue";
import ShareComponent from "./components/ShareComponent.vue";
import RateComponent from "./components/RateComponent.vue";
import SignInComponent from "./components/SignInComponent.vue";
import ActionNotification from "./components/ActionNotification.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const notification = ref<{ [name: string]: string } | null>(null)
store.fetchContentItem(store.itemId)
    .then((contentItem) => {
        if (!contentItem)
            return;
        const langCode = contentItem.languages.filter((row) => row.selected).pop()?.code
        if (langCode){
            window.postMessage({e: "language-switch", lang: langCode})
        }
    })

function clearNotification(){
    notification.value = null;
}

onMounted(() => {
    document.querySelector<HTMLElement>("body")?.addEventListener("notify", function(e: CustomEvent){
        if (e.detail?.message && e.detail?.type){
            notification.value = {
                message: e.detail.message,
                type: e.detail.type,
            }

            setTimeout(clearNotification, 1500)
        }
        // eslint-disable-next-line no-undef
    } as EventListener);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(store).page === 'details')
      ? (_openBlock(), _createBlock(DetailsScreen, {
          key: 0,
          onToggle: _unref(store).toggleModal
        }, null, 8, ["onToggle"]))
      : (_unref(store).page === 'player')
        ? (_openBlock(), _createBlock(PlayerComponent, { key: 1 }))
        : (_unref(store).page === 'preview')
          ? (_openBlock(), _createBlock(PreviewScreen, { key: 2 }))
          : _createCommentVNode("", true),
    (_unref(store).modal === 'share')
      ? (_openBlock(), _createBlock(ShareComponent, {
          key: 3,
          onToggle: _unref(store).toggleModal
        }, null, 8, ["onToggle"]))
      : _createCommentVNode("", true),
    (_unref(store).modal === 'rate')
      ? (_openBlock(), _createBlock(RateComponent, {
          key: 4,
          onToggle: _unref(store).toggleModal
        }, null, 8, ["onToggle"]))
      : _createCommentVNode("", true),
    (_unref(store).modal === 'sign-in')
      ? (_openBlock(), _createBlock(SignInComponent, {
          key: 5,
          onToggle: _unref(store).toggleModal
        }, null, 8, ["onToggle"]))
      : _createCommentVNode("", true),
    (notification.value)
      ? (_openBlock(), _createBlock(ActionNotification, {
          key: 6,
          message: notification.value.message,
          type: notification.value.type
        }, null, 8, ["message", "type"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})